var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCardRecordings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#FFF2E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M21.9983 11.4399C19.9097 11.4399 17.8681 12.0592 16.1315 13.2196C14.3949 14.3799 13.0414 16.0292 12.2421 17.9588C11.4429 19.8883 11.2337 22.0116 11.6412 24.06C12.0487 26.1085 13.0544 27.9901 14.5312 29.4669C16.0081 30.9438 17.8897 31.9495 19.9381 32.357C21.9866 32.7644 24.1098 32.5553 26.0394 31.7561C27.969 30.9568 29.6183 29.6033 30.7786 27.8667C31.939 26.1301 32.5583 24.0885 32.5583 21.9999C32.5557 19.2 31.4423 16.5155 29.4625 14.5357C27.4827 12.5559 24.7982 11.4425 21.9983 11.4399ZM21.9983 30.2132C20.3739 30.2132 18.7859 29.7315 17.4352 28.829C16.0845 27.9265 15.0318 26.6438 14.4102 25.143C13.7885 23.6422 13.6259 21.9908 13.9428 20.3975C14.2597 18.8043 15.0419 17.3408 16.1906 16.1922C17.3392 15.0435 18.8027 14.2613 20.396 13.9444C21.9892 13.6275 23.6406 13.7901 25.1414 14.4118C26.6422 15.0334 27.9249 16.0861 28.8274 17.4368C29.7299 18.7875 30.2116 20.3754 30.2116 21.9999C30.209 24.1774 29.3429 26.265 27.8031 27.8047C26.2634 29.3445 24.1758 30.2106 21.9983 30.2132ZM21.9983 15.351C20.6833 15.351 19.3978 15.741 18.3044 16.4715C17.211 17.2021 16.3588 18.2405 15.8555 19.4555C15.3523 20.6704 15.2206 22.0073 15.4772 23.297C15.7337 24.5868 16.367 25.7715 17.2968 26.7014C18.2267 27.6312 19.4114 28.2645 20.7012 28.521C21.9909 28.7776 23.3278 28.6459 24.5427 28.1427C25.7576 27.6394 26.7961 26.7872 27.5266 25.6938C28.2572 24.6004 28.6472 23.3149 28.6472 21.9999C28.6446 20.2373 27.9433 18.5476 26.6969 17.3013C25.4506 16.0549 23.7609 15.3536 21.9983 15.351Z",
    fill: "#DA3B2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCardRecordings);
export default __webpack_public_path__ + "static/media/iconCardRecordings.7ffc11279cb733cad6929e52d7d5ea38.svg";
export { ForwardRef as ReactComponent };